import i18n from "@/libs/i18n/i18n";
import {initialState} from "./initialState";
export default () => ({
  ...initialState
});
